export enum SectorResource {
  DTWINS = "dtwins",
  USER = "user",
  USER_GROUP = "userGroup",
}
